<p>balance-and-detail works!</p>
